<template>
  <div :title="data.name" class="flex-grow truncate">
    <div
      id="prompting-item"
      class="flex items-center gap-2 truncate"
      :class="{ 'py-4 border-b border-grey-200 pointer-events-none': readOnly }"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
    >
      <div
        class="flex items-center justify-center flex-shrink-0 w-10 text-sm font-semibold text-center text-teal-700 bg-teal-100 rounded outline-none h-11"
      >
        <BlTextBody1
          :text="data.abbreviation"
          class="font-semibold text-teal-700"
        />
      </div>

      <div
        class="flex items-center flex-grow h-10 px-1 rounded outline-none"
        :class="{ 'bg-slate-200': isHovered && !data.is_default }"
      >
        <BlTextBody1 :text="data.name" class="text-slate-1000" />
      </div>

      <div v-if="!data.is_default" class="relative self-start ml-auto">
        <div
          class="absolute flex items-center gap-2 transition-opacity duration-300 top-0.5 right-1"
          :class="{ 'opacity-100': isHovered, 'opacity-0': !isHovered }"
        >
          <div
            class="p-2 bg-white border rounded cursor-pointer border-slate-500 "
            @click="onRemove"
          >
            <BlIcon
              class="w-4 h-4 "
              icon="delete"
              :color="disabledDelete ? 'grey' : 'error'"
              :tooltip="tooltipDelete"
            />
          </div>
          <div
            class="p-2 bg-white border rounded cursor-pointer border-slate-500"
            @click="openEdit = true"
          >
            <BlIcon class="w-4 h-4 " icon="pencil-outline" color="grey" />
          </div>
        </div>
      </div>
    </div>

    <BlBackdrop
      v-if="openEdit"
      title="Edit prompt"
      label="Update"
      @backdrop-close="openEdit = false"
      @backdrop-action="onUpdate"
    >
      <div
        class="flex flex-col gap-5 px-8 overflow-y-auto"
        :style="{ width: '40rem', maxHeight: 'calc(100vh - 14rem)' }"
      >
        <div class="grid items-center grid-cols-6 gap-4 py-4">
          <BlInputText
            class="col-span-3"
            :input="{
              label: 'Score',
              placeholder: 'Type score',
              model: data.score,
              inputType: 'number',
              suffix: '%',
              min: 0,
              max: 100
            }"
            @changed="inputHandler"
          />

          <BlInputText
            class="col-span-3"
            :input="{
              label: 'Code',
              placeholder: 'Type code',
              model: data.abbreviation
            }"
            @changed="inputHandler"
          />

          <BlInputText
            class="col-span-6"
            :input="{
              label: 'Prompt name',
              placeholder: 'Type name',
              model: data.name
            }"
            @changed="inputHandler"
          />
        </div>
      </div>
    </BlBackdrop>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BlBackdrop from "../../BlBackdrop.vue";
import BlIcon from "../../BlIcon.vue";
import BlTextBody1 from "../../BlTextBody1.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputText from "../../BlInputText.vue";

export default {
  name: "PromptingClientItem",
  components: {
    BlIcon,
    BlTextBody2,
    BlBackdrop,
    BlTextBody1,
    BlInputText
  },
  props: ["prompt", "readOnly", "disabledDelete", "tooltipDelete"],
  data() {
    return {
      isHovered: false,
      openEdit: false,
      data: {
        id: null,
        name: "",
        abbreviation: "",
        score: null,
        is_default: false
      },
      errors: {
        name: false,
        abbreviation: false,
        score: false
      },
      symbolOpened: false,
      deleteOpened: false
    };
  },
  watch: {
    prompt: {
      deep: true,
      handler(val) {
        this.data = { ...val };
      }
    }
  },
  mounted() {
    this.data = { ...this.prompt };
  },
  methods: {
    ...mapActions(["showToast"]),
    inputHandler(payload) {
      if (payload.input.label === "Score") {
        this.data.score = payload.value;
      } else if (payload.input.label === "Code") {
        this.data.abbreviation = payload.value;
      } else if (payload.input.label === "Prompt name") {
        this.data.name = payload.value;
      }
    },
    onUpdate() {
      const { name, abbreviation, score } = this.data;
      if (!name) {
        this.errors.name = true;
        const title = "The prompt name should not be empty.";
        this.showToast({ title, message: "", type: "error" });
        return;
      }
      this.errors.name = false;

      if (!abbreviation.length || abbreviation.length > 3) {
        this.errors.abbreviation = true;
        const title =
          "The prompt code should consist of at least 1 and no more than 3 characters.";
        this.showToast({ title, message: "", type: "error" });
        return;
      }
      this.errors.abbreviation = false;

      if (score === null || score === "") {
        this.errors.score = true;
        const title = "The score should not be empty.";
        this.showToast({ title, message: "", type: "error" });
        return;
      }
      this.errors.score = false;
      this.$emit("update", this.data);
      this.openEdit = false;
    },
    onRemove() {
      this.$emit("delete", this.data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/repository/sbt/PromptingClientItem.vue